var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWordMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 639,
    height: 108,
    viewBox: "0 0 639 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 63,
    height: 88
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10H72.6164V98H10V10Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6164 76.377C72.6164 87.2521 65.2339 98.0009 41.3082 98.0009C17.3807 98.0009 10 87.2521 10 76.377V31.6151C10 20.7471 17.3807 10 41.3082 10C65.2339 10 72.6164 20.7471 72.6164 31.6151V37.432C72.6164 40.0873 71.7256 41.2247 69.0513 41.2247H55.9444C53.2702 41.2247 52.2541 40.0873 52.2541 37.432V35.2868C52.2541 29.4681 47.7999 27.0635 41.5622 27.0635C35.3263 27.0635 30.9991 29.4681 30.9991 35.2868V72.7141C30.9991 78.531 35.3263 80.9286 41.5622 80.9286C47.7999 80.9286 52.2541 78.531 52.2541 72.7141V68.6655C52.2541 66.0103 53.2702 64.8728 55.9444 64.8728H69.0513C71.7256 64.8728 72.6164 66.0103 72.6164 68.6655V76.377Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.278 58.2962H137.004V14.8014C137.004 12.1462 138.023 11.0087 140.694 11.0087H154.441C157.114 11.0087 158.005 12.1462 158.005 14.8014V93.1979C158.005 95.8531 157.114 96.9906 154.441 96.9906H140.694C138.023 96.9906 137.004 95.8531 137.004 93.1979V75.3685H99.4596C96.7871 75.3685 95.6422 74.352 95.6422 71.6968V61.9679C95.6422 61.0794 95.8962 60.1925 96.025 59.6913L109.007 14.8014C109.643 12.3968 110.915 11.0087 113.588 11.0087H127.331C130.006 11.0087 130.641 12.5265 130.006 14.8014L117.278 58.2962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.536 72.3344C252.554 76.5056 253.444 81.3078 253.571 82.3226C253.571 81.6864 254.081 78.1513 255.609 72.3344L270.879 12.9047C271.263 11.6376 271.771 11.0084 273.172 11.0084H277.88C279.152 11.0084 279.662 11.6376 279.281 12.9047L258.28 95.0939C257.897 96.354 257.264 96.9902 255.99 96.9902H250.645C249.371 96.9902 248.736 96.354 248.353 95.0939L232.955 34.6565C231.935 30.8568 231.427 26.8135 231.3 25.9267C231.173 26.6856 230.281 31.493 229.519 34.7774L214.119 95.0939C213.738 96.354 213.099 96.9902 211.7 96.9902H206.355C205.21 96.9902 204.573 96.354 204.192 95.0939L183.193 12.9047C182.812 11.6376 183.322 11.0084 184.721 11.0084H190.193C191.467 11.0084 191.973 11.6376 192.356 12.9047L207.502 72.3344C208.391 75.8764 209.537 81.6863 209.537 81.6863C209.537 81.6863 210.174 77.7727 211.573 72.3344L226.846 12.9047C227.227 11.6376 227.735 11.0084 229.136 11.0084H234.227C235.499 11.0084 236.009 11.6376 236.391 12.9047L251.536 72.3344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 306,
    y: 10,
    width: 56,
    height: 88
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.503 10.0004H361.612V98H306.503V10.0004Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.575 29.8488C352.575 22.5141 347.486 17.7049 333.994 17.7049C320.632 17.7049 315.541 22.5141 315.541 29.8488V78.1528C315.541 85.4858 320.632 90.2862 333.994 90.2862C347.486 90.2862 352.575 85.4858 352.575 78.1528V29.8488ZM306.503 28.459C306.503 18.3428 313.122 10.0004 333.994 10.0004C355.12 10.0004 361.612 18.3428 361.612 28.459V79.5409C361.612 89.657 355.12 98.0012 333.994 98.0012C313.122 98.0012 306.503 89.657 306.503 79.5409V28.459Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.417 18.722V54.3756H425.361C438.979 54.3756 443.943 49.5752 443.943 42.1125V30.8572C443.943 23.5224 438.979 18.722 425.361 18.722H407.417ZM407.417 61.9679V95.0942C407.417 96.3544 407.036 96.9906 405.635 96.9906H400.288C399.016 96.9906 398.508 96.3544 398.508 95.0942V12.9051C398.508 11.6379 399.016 11.0087 400.163 11.0087H425.361C446.487 11.0087 452.979 19.3512 452.979 29.4691V43.6285C452.979 51.4715 449.034 58.2962 437.197 60.8287L453.742 95.0942C454.25 96.2335 453.36 96.9906 451.959 96.9906H446.614C445.215 96.9906 444.961 96.2335 444.324 95.0942L428.543 61.9679H425.361H407.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.602 95.0945C545.366 95.9761 544.858 96.9909 543.711 96.9909H536.583C535.184 96.9909 534.422 96.104 533.658 95.0945L501.713 57.4097H497.769V95.0945C497.769 96.3547 497.386 96.9909 495.985 96.9909H490.64C489.241 96.9909 488.731 96.3547 488.731 95.0945V12.9036C488.731 11.6382 489.241 11.0073 490.64 11.0073H495.985C497.386 11.0073 497.769 11.6382 497.769 12.9036V50.585H501.713L531.113 12.7757C531.875 11.7661 532.892 11.0073 534.293 11.0073H540.15C541.422 11.0073 541.928 11.7661 541.037 12.9036L509.35 53.3664L544.602 95.0945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.953 95.0945C628.588 96.104 628.334 96.9909 626.933 96.9909H620.699C619.298 96.9909 618.535 96.104 617.9 95.0945L597.662 61.2076L578.062 95.0945C577.425 96.104 576.792 96.9909 575.39 96.9909H569.409C568.138 96.9909 567.88 95.9761 568.519 94.8387L592.954 53.1157L569.154 13.0333C568.519 12.0185 568.646 11.0073 569.918 11.0073H576.282C577.681 11.0073 578.447 11.8958 579.082 12.9036L598.68 45.6531L617.39 12.9036C618.025 11.7661 618.789 11.0073 620.06 11.0073H625.917C627.187 11.0073 627.443 11.7661 626.808 12.9036L603.136 53.3664L627.953 95.0945Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 638.282,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWordMark);
export default __webpack_public_path__ + "static/media/logo-word-mark.db48e25d1bcae29cb38c80fd8243404c.svg";
export { ForwardRef as ReactComponent };